// extracted by mini-css-extract-plugin
export default {"LoaderWrapper":"CustomLoader_LoaderWrapper__U+muT"};